import type { CouncilMemberRow } from '../../enterpriseaigovernance/framework';

type Props = { members?: CouncilMemberRow[] };

export function AIGovernanceCouncilPanel({ members = [] }: Props) {
  return (
    <div className="space-y-2">
      {members.map((m) => (
        <div key={m.role} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{m.role}</p>
            <span className="shrink-0 rounded-full bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
              {m.reviewCycle}
            </span>
          </div>
          <p className="mt-1 text-xs text-slate-500">{m.responsibility}</p>
          <p className="mt-0.5 text-xs font-medium text-brand-600">{m.decisionRights}</p>
        </div>
      ))}
    </div>
  );
}
